import { FC } from "react";

import { Box } from "@mui/material";
import { OrganizationCountry } from "@simplyk/common";

import { CreditCardFormPaymentMethod } from "@/forms-design-system/FormPaymentMethod";
import { AchFormPaymentMethod } from "@/forms-design-system/FormPaymentMethod/AchFormPaymentMethod";
import { ChequeFormPaymentMethod } from "@/forms-design-system/FormPaymentMethod/ChequeFormPaymentMethod";
import { PadFormPaymentMethod } from "@/forms-design-system/FormPaymentMethod/PadFormPaymentMethod";

interface PreviewPaymentMethodsProps {
  country: OrganizationCountry;
}

export const PreviewPaymentMethods: FC<PreviewPaymentMethodsProps> = ({ country }) => {
  return (
    <Box>
      <CreditCardFormPaymentMethod />
      {country === OrganizationCountry.Canada && <PadFormPaymentMethod />}
      {country === OrganizationCountry.UnitedStates && <AchFormPaymentMethod />}
      <ChequeFormPaymentMethod />
    </Box>
  );
};
